import React from 'react';

import ReactWebChat, { createDirectLine, createStore } from 'botframework-webchat';
import UUID from 'uuidjs';
import config from './config';

export default class extends React.Component {

  livechatInterval = undefined;
  isInLivechatQueue = false;

  styleOptions = {

    backgroundColor: 'rgb(255, 255, 255)',
    avatarBorderRadius: '50%',
    avatarSize: 40,
    botAvatarInitials: "",
    botAvatarBackgroundColor: 'rgb(0, 46, 115)',
    botAvatarImage: 'assets/img/amtrust-a-icon-small.png',
    userAvatarInitials: "",
    userAvatarBackgroundColor: 'transparent',
    userAvatarImage: 'assets/img/user-chat-icon.png',
    bubbleBackground: 'rgb(250, 250, 250)',
    bubbleBorderColor: 'rgb(199, 199, 199)',
    bubbleBorderRadius: '0 10px 10px',
    bubbleBorderWidth: 1,
    bubbleFromUserBackground: 'rgb(42, 86, 143)',
    bubbleFromUserBorderColor: 'rgb(42, 86, 143)',
    bubbleFromUserBorderRadius: '10px 0 10px 10px',
    bubbleFromUserBorderStyle: 'solid',
    bubbleFromUserBorderWidth: 1,
    bubbleFromUserTextColor: 'rgb(255, 255, 255)',
    bubbleFromUserNubOffset: 'bottom',
    bubbleFromUserNubSize: 0,
    groupTimestamp: true,
    sendTimeout: 20000,
    sendTimeoutForAttachments: 120000,
    timestampColor: undefined,
    timestampFormat: 'relative',
    sendBoxBackground: 'rgb(242, 243, 244)',
    sendBoxHeight: 72,
    sendBoxTextColor: 'rgb(47, 47, 47)',

    suggestedActionBackground: 'rgb(255, 255, 255)',
    suggestedActionBorderColor: 'rgb(199, 199, 199)',
    suggestedActionBorderRadius: 25,
    suggestedActionBorderStyle: 'solid',
    suggestedActionBorderWidth: 1,
    suggestedActionHeight: 30,
    suggestedActionImageHeight: 20,
    suggestedActionTextColor: 'rgb(47, 47, 47)',

  };

  constructor(props) {
    super(props);

    this.store = createStore({}, ({ dispatch }) => next => action => {
      if (action.type === 'DIRECT_LINE/CONNECT_FULFILLED') {
        dispatch({
          type: 'WEB_CHAT/SET_NOTIFICATION',
          payload: {
            id: 'connectivitystatus',
            level: 'info',
            message: 'connecting'
          }
        });
      }
      else if (action.type === 'DIRECT_LINE/INCOMING_ACTIVITY') {
        var activity = action.payload.activity;
        if (activity.from.role === 'bot') {
          this.connected = true;
          dispatch({
            type: 'WEB_CHAT/SET_NOTIFICATION',
            payload: {
              id: 'connectivitystatus',
              level: 'success',
              message: 'connected'
            }
          });
          dispatch({
            type: 'WEB_CHAT/DISMISS_NOTIFICATION',
            payload: {
              id: 'connect-fail'
            }
          });
        }
        if (activity.type === 'event') {
          if (activity.name === 'livechat:beginqueue') {
            this.beginLiveChatQueue(dispatch);
          }
          else if (activity.name === 'livechat:endqueue') {
            this.endLiveChatQueue(dispatch);
          }
        }
      }
      else if (!this.connected && action.type === 'DIRECT_LINE/POST_ACTIVITY_REJECTED') {
        dispatch({
          type: 'WEB_CHAT/SET_NOTIFICATION',
          payload: {
            id: 'connectivitystatus',
            level: 'error',
            message: 'failedtoconnect'
          }
        });

        this.showUnavailableNotification(dispatch);
      }
      else if (action.type === 'DIRECT_LINE/UPDATE_CONNECTION_STATUS' && action.payload.connectionStatus === 4) {
        this.showUnavailableNotification(dispatch);
      }
      else if ((!this.connected || this.isInLivechatQueue) && (action.type === 'WEB_CHAT/SUBMIT_SEND_BOX' || action.type === 'WEB_CHAT/SET_SEND_BOX')) {
        return null;
      }

      return next(action);
    });

    this.state = {};
  }

  showUnavailableNotification(dispatch) {
    dispatch({
      type: 'WEB_CHAT/SET_NOTIFICATION',
      payload: {
        id: 'connect-fail',
        level: 'error',
        message: 'Chat is unavailable. Please contact the Customer Care Center at (877) 528-7878 for further assistance.'
      }
    });
  }

  beginLiveChatQueue(dispatch) {
    if (!this.livechatInterval) {
      this.livechatInterval = setInterval(() => {
        dispatch({
          type: 'WEB_CHAT/SET_NOTIFICATION',
          payload: {
            id: 'livechat-queue',
            level: 'info',
            message: 'We appreciate your patience, all representatives are currently assisting other customers. We will be with you shortly. Please click cancel if you no longer want to speak to a customer care representative.'
          }
        });
      }, 2 * 60 * 1000);
    }
    this.isInLivechatQueue = true;
  }

  endLiveChatQueue(dispatch) {
    if (this.livechatInterval) {
      clearInterval(this.livechatInterval);
    }
    this.isInLivechatQueue = false;

    dispatch({
      type: 'WEB_CHAT/DISMISS_NOTIFICATION',
      payload: {
        id: 'livechat-queue'
      }
    });
  }

  showLivechatNotification() {
    
  }

  componentDidMount() {
    this.fetchToken();
  }

  async fetchToken() {
    try {
      const userId = "dl_" + this.checkForUserId();
      const res = await fetch(config.tokenUrl, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(userId)
      });
      const { token } = await res.json();

      this.setState(() => ({
        directLine: createDirectLine({ token })
      }));
    } catch (error) {
      console.log("Error requesting token");
      console.log(error);
      //Pass invalid token to display unable to connect message
      this.setState(() => ({
        directLine: createDirectLine({ token: "" })
      }));
    }
  }

  checkForUserId() {
    const currentId = window.localStorage.getItem('amtChatId');
    return currentId !== null ? currentId : this.generateUserGuid();
  }

  generateUserGuid() {
    const newId = UUID.generate().toString();
    window.localStorage.setItem('amtChatId', newId);
    return newId;
  }

  render() {
    return this.state.directLine ? (
      <ReactWebChat
        className="chat"
        directLine={this.state.directLine}
        store={this.store}
        styleOptions={this.styleOptions}
      />
    ) : (
        <div>Connecting to bot&hellip;</div>
      );
  }
}
